import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CustomButton from "src/components/atoms/buttons/CustomButton";
import { FormDefaultsProps } from "src/hooks/forms/useFormDefaults";

type Props = {
    formikProps: any;
    formDefaultsProps: FormDefaultsProps;
    clearLabel?: string;
};

export const FormDefaultsMenu = ({ formikProps, formDefaultsProps, clearLabel }: Props) => {
    const { enabled, setEnabled, clearStoredDefaults, clearFields } = formDefaultsProps;

    return (
        <>
            <MenuItem dense onClick={() => setEnabled(!enabled)}>
                <Checkbox
                    size="small"
                    checked={enabled}
                    icon={<BookmarkBorderIcon fontSize="small" />}
                    checkedIcon={<BookmarkIcon fontSize="small" />}
                />
                <CustomButton variant="text" title={!enabled ? "Enable Form Defaults" : "Disable Form Defaults"} />
            </MenuItem>

            <CustomButton
                variant="text"
                title={clearLabel ?? "Reset Form Defaults"}
                icon={<RestartAltIcon fontSize="small" />}
                onClick={() => {
                    clearStoredDefaults();
                    clearFields(formikProps);
                }}
            />

            <Divider />
        </>
    );
};